module.exports = __webpack_public_path__ + "img/TS_ICON_CRITTERS.86048c81.png";